require('../step.scss');

const PropTypes = require('prop-types');

// @core
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
// @components
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
// @constants
const {ACCOUNT_CANCEL_CHECKS_ID} = require('constants/operationTypes');
const { API_ENTERPRISE_NUMBER, API_CENTER } = require('constants/index');

class AccountCancelChequesStep2 extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const {immAccounts, accountId, immStep} = this.props;
        const newProduct = immAccounts.getIn(['byId', accountId, 'newProduct']);
        const newContractNumber = immAccounts.getIn(['byId', accountId, 'newContractNumber']);
        const originAccount = API_ENTERPRISE_NUMBER + API_CENTER + newProduct + newContractNumber
        const number = immStep.get('number');
        const operative = formatText('operatives-cancelCheque');

        const operationParams = {
            originAccount
        }

        return (
            <div className="account-cancel-cheques-step">
                <header className="account-cancel-cheques-step__header">
                    <h5 className="account-cancel-cheques-step__title">
                        <FormattedText
                            value="accountCancelCheques-secondStepTitle"
                            injectedStrings={[number]}
                        />
                    </h5>
                </header>
                <ContactCenterRender>
                    <ConfirmationScript
                        operative={operative}
                        confirmationType={CONFIRMATION_SCRIPT_GREETING}
                    />
                    <ConfirmationScript
                        confirmationType={CONFIRMATION_SCRIPT_AGREEMENT}
                    />
                </ContactCenterRender>
                <article>
                    <SignaturePattern
                        operationType={ACCOUNT_CANCEL_CHECKS_ID}
                        operationParams={operationParams}
                    />

                </article>
            </div>
        );
    }
}

AccountCancelChequesStep2.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    accountId: PropTypes.string.isRequired,
    immStep: PropTypes.object.isRequired
}

module.exports = AccountCancelChequesStep2;